// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-9d2831a4]{-webkit-line-clamp:4;max-height:5em}.text[data-v-9d2831a4],.title[data-v-9d2831a4]{-webkit-box-orient:vertical;display:-webkit-box}.text[data-v-9d2831a4]{-webkit-line-clamp:3;max-height:4.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
